import { useCallback, useMemo } from "react";

import ARCRow from "components/ARC/ARCRow";

import { useFleet } from "providers/FleetProvider";

const ARCStatusPage = () => {
    const { arcsInfo, arcStatuses } = useFleet();
    const isOnline = useCallback(
        ({ serialNumber }) => {
            return arcStatuses[serialNumber]?.online === true;
        },
        [arcStatuses]
    );
    const onlineArcs = useMemo(() => arcsInfo.filter(isOnline), [arcsInfo, isOnline]);
    const offlineArcs = useMemo(
        () => arcsInfo.filter((arc) => !isOnline(arc)),
        [arcsInfo, isOnline]
    );

    return (
        <div className="scroll-vertical flex max-h-[calc(100%-5.25rem)] w-full flex-col space-y-16 p-6">
            <ARCRow title={"Online ARC"} arcsInfo={onlineArcs} />
            <ARCRow title={"Offline ARC"} arcsInfo={offlineArcs} />
        </div>
    );
};

export default ARCStatusPage;
